import React, { Suspense, lazy } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// core
import * as LoginSession from "@mochi/misc/auth/util/loginSession";
import { WithReduxPrivateRoute as PrivateRoute } from "../../private-route";
import Maintenance from "../../maintenance-page/Maintenance";

// component
const Login = lazy(() => import('../../login/pages/Login'));
const Logout = lazy(() => import('../../logout/pages/StyledConnectedLogout'));
const HomeScreen = lazy(() => import('../../home-screen/pages/HomeScreen'));
const Privacy = lazy(() => import('../../privacy/pages/Privacy'));
const RegisterRoom = lazy(() => import('../../register-room/pages/RegisterRoom'));
const FinishRegisterRoom = lazy(() => import('../../finish-register-room/pages'));
const BookingCalendar = lazy(() => import('../../booking-calendar/pages/'));
const RegisterOption = lazy(() => import('../../register-option/pages/RegisterOption'));
const BookingInformation = lazy(() => import('../../booking-information/pages'));
const LoginBookingNumber = lazy(() => import('../../login-booking-number/pages/LoginBookingNumber'));
const RebookOverView = lazy(() => import('../../rebook-overview/pages'));
const DownLoadFail = lazy(() => import('../../DownLoadFail/index'));

const authFnc = () => !!LoginSession.get();

export const Routes = () => (
  <Suspense fallback={<div />}>
    <Switch>

      <Route
        path="/login"
        render={props =>
          authFnc() ? <Redirect to="/register-room" /> : <Login {...props} />
        }
      />
      <Route
        path="/login-booking-number"
        render={props =>
          authFnc() ? <Redirect to="/booking-information" /> : <LoginBookingNumber {...props} />
        }
      />
      <Route exact path="/privacy" component={Privacy} />
      <Route exact path="/maintenance" component={Maintenance} />

      <PrivateRoute
        exact
        path="/logout"
        component={Logout}
        callbackAuth={authFnc}
      />
      <PrivateRoute exact path="/register-room" callbackAuth={authFnc} component={RegisterRoom} />
      <PrivateRoute exact path="/booking-calendar" callbackAuth={authFnc} component={BookingCalendar} />
      <PrivateRoute exact path="/booking-calendar/:from" callbackAuth={authFnc} component={BookingCalendar} />
      <PrivateRoute exact path="/register-option" callbackAuth={authFnc} component={RegisterOption} />
      <PrivateRoute exact path="/finish-register-room" callbackAuth={authFnc} component={FinishRegisterRoom} />
      <PrivateRoute exact path="/booking-information" callbackAuth={authFnc} component={BookingInformation} />
      <PrivateRoute exact path="/booking-information/:from" callbackAuth={authFnc} component={BookingInformation} />
      <PrivateRoute exact path="/rebook-overview" callbackAuth={authFnc} component={RebookOverView} />
      <Route exact path="/download-error" component={DownLoadFail} />
      <Route path="/:residentAccessUrl" component={HomeScreen} />

      <Route render={() => (<p> Page not found! </p>)} />
    </Switch>
  </Suspense>
);
